import { DirectoryTypeConsts } from 'client/util/Constants/DirectoryConstants';
import ActiveDirectoryApi from 'client/api/v2/ActiveDirectoryApi';
import CreateDirectoryModal from 'client/directories/components/CreateDirectoryModal.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import GSuiteApi from 'client/api/v2/GSuiteApi';
import GSuiteImport from 'client/directories/GSuite/GSuiteImport.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import ModalEventBus, { ModalEvents } from 'components/Modal/ModalEventBus';
import O365Api from 'client/api/v2/O365Api';
import O365Import from 'client/directories/Office365/O365Import.vue';
import ScimUsersImport from 'client/applications/import/ScimUsersImport';

export default {
  showCreateActiveDirectoryDirectoryDialog() {
    EventHelper.triggerAddNewDirectoryTypeSelected(
      { resourceName: DirectoryTypeConsts.activeDirectory },
    );
    ModalEventBus.open({
      component: CreateDirectoryModal,
      componentProps: {
        directoryType: DirectoryTypeConsts.activeDirectory,
        onClick: name => ActiveDirectoryApi.activate(name),
        kbUrl: KbArticleUrls.gettingStartedActiveDirectory,
      },
    });
  },

  showCreateGSuiteDirectoryDialog() {
    EventHelper.triggerAddNewDirectoryTypeSelected(
      { resourceName: DirectoryTypeConsts.gSuite },
    );
    ModalEventBus.open({
      component: CreateDirectoryModal,
      componentProps: {
        directoryType: DirectoryTypeConsts.gSuite,
        onClick: name => GSuiteApi.activate(name),
        kbUrl: KbArticleUrls.gSuiteImport,
        kbLinkText: 'Google Workspace Integration Guide',
      },
    });
  },

  showCreateO365DirectoryDialog() {
    EventHelper.triggerAddNewDirectoryTypeSelected(
      { resourceName: DirectoryTypeConsts.office365 },
    );
    ModalEventBus.open({
      component: CreateDirectoryModal,
      componentProps: {
        directoryType: DirectoryTypeConsts.office365,
        onClick: name => O365Api.activate(name),
        kbUrl: KbArticleUrls.officeImport,
      },
    });
  },

  showDirectoryImportUsersModal(directoryType, modelId) {
    const openImportUsersModal = () => {
      let directoryIdPropName;
      let importModalComponent;

      switch (directoryType) {
        case DirectoryTypeConsts.gSuite:
          directoryIdPropName = 'gSuiteId';
          importModalComponent = GSuiteImport;
          break;
        case DirectoryTypeConsts.office365:
          directoryIdPropName = 'o365Id';
          importModalComponent = O365Import;
          break;
        default:
          break;
      }

      if (directoryIdPropName && importModalComponent && modelId) {
        ModalEventBus.open({
          component: importModalComponent,
          componentProps: { [directoryIdPropName]: modelId },
        });
      }
    };

    if (ModalEventBus.isModalOpen()) {
      ModalEventBus.$once(ModalEvents.close, openImportUsersModal);
    } else {
      openImportUsersModal();
    }
  },

  showScimUsersImportModal(scimAppId = '', showResultsView = false, resultsJobId = '') {
    const component = ScimUsersImport;
    const componentProps = { scimAppId, showResultsView, resultsJobId };

    ModalEventBus.open({ component, componentProps });

    return Promise.resolve();
  },
};
